import { ComponentRef, Directive, ElementRef, OnDestroy, Renderer2, ViewContainerRef, effect, inject, input } from "@angular/core";
import { ProgressSpinner } from "primeng/progressspinner";

@Directive({
    selector: "[kno2LoadingOverlay]"
})
export class Kno2LoadingOverlayDirective implements OnDestroy {
    public readonly loading = input<boolean | null>(false, { alias: "kno2LoadingOverlay" });

    private readonly vcr = inject(ViewContainerRef);
    private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);
    private readonly renderer = inject(Renderer2);

    private spinnerRef: ComponentRef<ProgressSpinner> | null = null;
    private overlayEl: HTMLElement | null = null;
    private positionWasModified = false;

    constructor() {
        effect(() => {
            const isLoading = !!this.loading();
            if (isLoading && !this.overlayEl) this.show();
            else if (!isLoading && this.overlayEl) this.hide();
        });
    }

    public ngOnDestroy(): void {
        this.hide();
    }

    private show(): void {
        const hostEl = this.host.nativeElement;
        if (getComputedStyle(hostEl).position === "static") {
            this.renderer.setStyle(hostEl, "position", "relative");
            this.positionWasModified = true;
        }

        const overlay = this.renderer.createElement("div");
        this.renderer.addClass(overlay, "kno2-loading-overlay");

        this.spinnerRef = this.vcr.createComponent(ProgressSpinner);
        this.renderer.appendChild(overlay, this.spinnerRef.location.nativeElement);
        this.renderer.appendChild(hostEl, overlay);

        this.overlayEl = overlay;
    }

    private hide(): void {
        if (this.overlayEl) {
            this.renderer.removeChild(this.host.nativeElement, this.overlayEl);
            this.overlayEl = null;
        }
        if (this.spinnerRef) {
            this.spinnerRef.destroy();
            this.spinnerRef = null;
        }
        if (this.positionWasModified) {
            this.renderer.removeStyle(this.host.nativeElement, "position");
            this.positionWasModified = false;
        }
    }
}
